import { observer } from 'mobx-react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logMountingPerformance } from 'owa-analytics';
import showHideActionsPanelCallout from '../../actions/actionsPanelActions/showHideActionsPanelCallout';
import updateSaveUserChoice from '../../actions/actionsPanelActions/updateSaveUserChoice';
import FilePickerActionsPanelViewState from '../../store/schema/FilePickerActionsPanelViewState';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

export interface FilePickerActionsPanelCheckboxViewProps {
    viewState: FilePickerActionsPanelViewState;
    rememberUserChoiceText: string;
}

const styles = require('./FilePickerActionsPanelCheckboxView.scss');

// This component is responsible for the "remember my choice" cehckbox in the File Picker actions panel.
@observer
@logMountingPerformance('FilePickerActionsPanelCheckboxView')
export default class FilePickerActionsPanelCheckboxView extends React.Component<
    FilePickerActionsPanelCheckboxViewProps,
    {}
> {
    private checkboxIconElement = null;

    render() {
        return (
            <div className={styles.infoCheckboxWrapper}>
                <Checkbox
                    checked={this.props.viewState.saveUserChoice}
                    label={this.props.rememberUserChoiceText}
                    onChange={this.onCheckboxClicked}
                    className={styles.checkbox}
                />
                <span
                    className={styles.infoIconContainer}
                    ref={this.getCheckboxIconElement}
                    onMouseOver={() => showHideActionsPanelCallout(true, this.props.viewState)}>
                    <Icon className={styles.infoIcon} iconName={ControlIcons.Info} />
                </span>
                {this.props.viewState.isCalloutVisible && (
                    <Callout
                        gapSpace={0}
                        target={this.checkboxIconElement}
                        isBeakVisible={true}
                        beakWidth={10}
                        directionalHint={DirectionalHint.rightCenter}
                        onDismiss={() => showHideActionsPanelCallout(false, this.props.viewState)}>
                        <div className={styles.checkboxInfoCallout}>
                            <div className={styles.checkboxInfoCalloutLine1}>
                                {strings.ActionsPanel_InfoCalloutTextLine1}
                            </div>
                            <div>{strings.ActionsPanel_InfoCalloutTextLine2}</div>
                        </div>
                    </Callout>
                )}
            </div>
        );
    }

    private onCheckboxClicked = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        updateSaveUserChoice(this.props.viewState, checked);
    };

    private getCheckboxIconElement = (element: HTMLElement) => {
        this.checkboxIconElement = element;
    };
}
